import React, { PureComponent } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import SectionType, { SectionModel } from '@nucleo/section';
import { Section } from '@gravity/section';
import WidgetState from '@gravity/widget-state';
import { FrontEndError } from '@gravity/g-axios';

const Wrapper = styled.div.attrs({
  className: 'stx-SectionWidget',
})`
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
  box-sizing: border-box;
  text-align: left;
`;

/**
 * The section widget is used to display a specific section for a point of sales
 */
class SectionWidget extends PureComponent {
  componentWillMount() {
    this.props.load();
  }
  componentDidCatch(error, info) {
    // You can also log the error to an error reporting service
    this.props.logError(FrontEndError.RenderWidgetError, error, info);
  }
  render() {
    const sectionData = this.props.section;
    const { LOADING, ERROR } = sectionData;
    let curState;
    if (ERROR || this.props.configError) {
      curState = 'ERROR';
    } else if (LOADING) {
      curState = 'LOADING';
    }
    return (
      <Wrapper>
        <WidgetState state={curState} code={this.props.configErrorCode} />
        {SectionModel.hasData(sectionData) && (
          <Section
            section={sectionData}
            aspectRatio={this.props.aspectRatio}
            randomOrder={this.props.randomOrder}
            columns={this.props.columns}
            maxInSlider={this.props.maxInSlider}
            waitingListEnabled={this.props.waitingListEnabled}
            currencyCode={this.props.currencyCode}
          />
        )}
      </Wrapper>
    );
  }
}

SectionWidget.propTypes = {
  /**
   * Global config : contains the point of sales that will provide information. To be passed in the STX.widgets.start function.
   */
  hostname: PropTypes.string.isRequired,
  /**
   * Global config : contains the api key related to the point of sales. To be passed in the STX.widgets.start function.
   */
  apiKey: PropTypes.string.isRequired,
  /**
   * Global config : Explicitely pass the language to the widget that will be loaded. If not passed, the default language of the institution will be used
   */
  language: PropTypes.string,
  /**
   * The code of the section to display
   */
  sectionCode: PropTypes.string.isRequired,
  /**
   * The Aspect ratio for the image.
   */
  aspectRatio: PropTypes.oneOf(['VERTICAL', 'HORIZONTAL', 'WIDE', 'SQUARE', 'LANDSCAPE']),
  /**
   * Override the default randomOrder value defined in the section.
   */
  randomOrder: PropTypes.bool,
  /**
   * Override the default number of columns defined in the section.
   */
  columns: PropTypes.number,
  /**
   * Override the maximum items in slider value defined in the section
   */
  maxInSlider: PropTypes.number,
  /**
   * @IGNORE Contains the currency in which the price should be displayed, generated by config load
   */
  currencyCode: PropTypes.string.isRequired,
  /**
   *  @IGNORE generated, define if an error happend at the config level.
   */
  configError: PropTypes.bool,
  /**
   *  @IGNORE generated, define what kind of error happened at the config level
   */
  configErrorCode: PropTypes.string,
  /**
   *  @IGNORE point of sales configuration
   */
  waitingListEnabled: PropTypes.bool,
  /**
   * @IGNORE generated catalog after a load of data
   */
  section: SectionType,
  /**
   * @IGNORE generated function to load the catalog dated
   */
  load: PropTypes.func.isRequired,
  /**
   * @IGNORE generated function to log in case of error
   */
  logError: PropTypes.func.isRequired,
};
SectionWidget.defaultProps = {
  aspectRatio: null,
  randomOrder: null,
  columns: null,
  maxInSlider: null,
  waitingListEnabled: null,
  section: null,
  configError: false,
  configErrorCode: null,
};

export default SectionWidget;
